export const LOGS_PAGE_LIMIT = 500;
